var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Assessment',{attrs:{"parent-path":"/child_assess","childAccountNames":_vm.childAccountNames,"assess-data":_vm.assessData,"loading":_vm.loading,"page":_vm.currentPage,"page-total":_vm.pageTotal}})
}
var staticRenderFns = []

export { render, staticRenderFns }